import React from 'react';

function normalizeSubject(subject) {
  const value = String(subject || '').trim().toLowerCase();

  if (!value) return '[Subject]';
  if (value === 'math' || value === 'mathematics') return 'Mathematics';
  if (value === 'ela' || value === 'english language arts') {
    return 'English Language Arts';
  }

  return String(subject)
    .trim()
    .replace(/\b\w/g, char => char.toUpperCase());
}

const LCVTopBar = ({metadata}) => {
  const gradeLabel = metadata?.grade ? `Grade ${metadata.grade}` : '[Grade]';
  const subjectLabel = normalizeSubject(metadata?.subject);

  return (
    <div className="lcv-top-bar">
      <div className="lcv-course-badge">
        <span className="lcv-course-label">
          {gradeLabel} &bull; {subjectLabel}
        </span>
        <span className="lcv-course-title">{metadata?.topic || '[topic]'}</span>
      </div>
    </div>
  );
};

export default LCVTopBar;
